// Signed URLs and tokens must never reach logs, analytics or error reports.
const SIGNED_QUERY =
  /([?&](?:X-Amz-[A-Za-z0-9-]+|AWSAccessKeyId|Signature|Expires|access_token|refresh_token|csrf_token)=)[^&#\s"']*/gi;
const COOKIE_PAIR = /\b(access_token|refresh_token|csrf_token)=[^;&\s"']+/gi;
const BEARER = /\bBearer\s+[A-Za-z0-9._~+/=-]+/gi;

export function scrubText(input: string): string {
  return input
    .replace(SIGNED_QUERY, "$1[redacted]")
    .replace(COOKIE_PAIR, "$1=[redacted]")
    .replace(BEARER, "Bearer [redacted]");
}

/** Deep-scrubs strings in an error-reporter event/breadcrumb (use as Sentry `beforeSend`/`beforeBreadcrumb`). */
export function scrubEvent<T>(value: T): T {
  if (typeof value === "string") return scrubText(value) as T;
  if (Array.isArray(value)) return value.map(scrubEvent) as T;
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, scrubEvent(v)])) as T;
  }
  return value;
}
